import LoadableBaseline from './loadable_baseline'
import ReactComponent from 'lib/modulor/react_component'

ReactComponent.register(LoadableBaseline, 'Modulor.Baseline')
